import { addPromoCode } from '../../../../actions/siteadmin/PromoCode/addPromoCode';
import showToaster from '../../../../helpers/toastrMessgaes/showToaster';
import { demoRestrictionEncode } from '../../../../actions/demoRestriction';

async function submit(values, dispatch) {
    if (!values || !values.imageName) {
        return showToaster({ messageId: 'pleaseUpload', toasterType: 'error' });
    }
    const isRestrict = await dispatch(demoRestrictionEncode({}));
    const payload = {
        ...values,
        isRestrict,
    };
    await dispatch(addPromoCode(payload));
}

export default submit;